import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type ChatActionMode = 'navigate' | 'toast';

export const chatActionModeAtom = atomWithStorage<ChatActionMode>(
  'fs.chat.actionMode',
  'navigate',
);

/**
 * Plan / Run toggle in the chat input. `plan` (default): the agent shows a
 * plan and waits for approval before changing assets or running an addon.
 * `run`: plans are approved automatically, except plans over 25 assets or
 * that delete fields — the proxy enforces both (filespin-mcp-server
 * docs/design/chat-proxy.md, "Plan Mode").
 */
export type ChatAgentMode = 'plan' | 'run';

export const chatAgentModeAtom = atomWithStorage<ChatAgentMode>(
  'fs.chat.agentMode',
  'plan',
);

export const chatMaximizedAtom = atomWithStorage<boolean>(
  'fs.chat.maximized',
  false,
);

/**
 * In-memory override consulted by chat consumers (dispatcher, SSE stream,
 * chat context) to temporarily force a different action mode without
 * touching the user's persisted preference. Used by the onboarding
 * in-app agent run so a tool's `navigate` action doesn't yank the user
 * out of `/signup/:code` mid-flow.
 */
export const chatActionModeOverrideAtom = atom<ChatActionMode | null>(null);

/** Effective mode = override (if set) ?? persisted preference. */
export const effectiveChatActionModeAtom = atom<ChatActionMode>((get) => {
  return get(chatActionModeOverrideAtom) ?? get(chatActionModeAtom);
});
